import Signup from "../components/Signup/Signup";
import Layout from "../Layout/Layout";

const SignupPage = () => {
  return (
    <Layout>
      <Signup />
    </Layout>
  );
};

export default SignupPage;
